import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Command } from 'lucide-react';

interface QuickReferenceItem {
  keys?: string[];
  command?: string;
  description: string;
}

interface QuickReferenceCardProps {
  title: string;
  items: QuickReferenceItem[];
}

export const QuickReferenceCard: React.FC<QuickReferenceCardProps> = ({ title, items }) => {
  return (
    <div className='not-prose my-6'>
      <Card>
        <CardHeader>
          <div className='flex items-center gap-2'>
            <Command className='h-5 w-5 text-primary' />
            <CardTitle className='text-lg'>{title}</CardTitle>
          </div>
        </CardHeader>
        <CardContent>
          <div className='space-y-3'>
            {items.map((item, index) => (
              <div key={index} className='flex items-start justify-between gap-4 text-sm'>
                <div className='flex-1'>
                  <span className='text-muted-foreground'>{item.description}</span>
                </div>
                {item.keys && (
                  <div className='flex gap-1 flex-shrink-0'>
                    {item.keys.map((key, keyIndex) => (
                      <React.Fragment key={keyIndex}>
                        {keyIndex > 0 && <span className='text-muted-foreground mx-1'>+</span>}
                        <kbd className='px-2 py-1 text-xs font-semibold bg-muted border border-border rounded'>
                          {key}
                        </kbd>
                      </React.Fragment>
                    ))}
                  </div>
                )}
                {item.command && (
                  <code className='px-2 py-1 text-xs font-mono bg-muted border border-border rounded flex-shrink-0'>
                    {item.command}
                  </code>
                )}
              </div>
            ))}
          </div>
        </CardContent>
      </Card>
    </div>
  );
};
